import { CheckableFieldContext } from "./chunk-EYE6MH2Q.js";
import { Label_default } from "./chunk-T45SNPZ5.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckableField/CheckableField.Label.tsx
import { useContext } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CheckableFieldLabel = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  const {
    id,
    label
  } = useContext(CheckableFieldContext);
  return /* @__PURE__ */jsx(Label_default, __spreadProps(__spreadValues({}, rest), {
    as: "span",
    id: "".concat(id, "-label"),
    className: clsx("pd:checkable-field__label", className),
    children: children || label
  }));
};
var CheckableField_Label_default = CheckableFieldLabel;
export { CheckableField_Label_default };